module.exports = __webpack_public_path__ + "static/media/23.035be3b9.jpg";